import { Box, Text, VStack } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, FormSwitch, FormTextarea } from "@/components/jobOffer/ui";
import { SectionCard, SectionHeader, Grid2 } from "@/components/jobOffer/ui/layout";
import { RepeatableText } from "@/components/jobOffer/ui/listHelpers";

const ADDRESS_FORM_OPTIONS = [
    { value: "Formal", label: "Forma grzecznościowa (Pan/Pani)" },
    { value: "Informal", label: "Forma nieformalna (Ty)" },
];

const MESSAGE_LENGTH_OPTIONS = [
    { value: "Short", label: "Krótkie" },
    { value: "Medium", label: "Średnie" },
    { value: "Long", label: "Długie" },
];

const MAX_QUESTIONS_OPTIONS = [1, 2, 3, 4, 5].map(n => ({ value: String(n), label: String(n) }));

const SALES_INITIATIVE_OPTIONS = [
    { value: "Low", label: "Niski -- agent głównie odpowiada, nie naciska" },
    { value: "Medium", label: "Średni -- agent proponuje kolejny krok, nie forsuje" },
    { value: "High", label: "Wysoki -- agent aktywnie sprzedaje i domyka" },
];

const StepConversationStyle = ({ values, onChange }) => {
    const style = values.conversationStyle ?? {};
    const set = (patch) => onChange({ ...values, conversationStyle: { ...style, ...patch } });

    return (
        <VStack w="full" align="stretch" gap={4}>
            <SectionCard>
                <SectionHeader number={17} title="Tożsamość i przedstawianie się" subtitle="Kim jest Agent i jak zaczyna rozmowę" />
                <VStack align="stretch" gap={3}>
                    <Grid2>
                        <Field label="Imię handlowca AI">
                            <FormInput value={style.agentName ?? ""} onChange={(e) => set({ agentName: e.target.value })} placeholder='np. "Marek"' />
                        </Field>
                        <Field label="Styl marki / branży">
                            <FormInput value={style.brandStyle ?? ""} onChange={(e) => set({ brandStyle: e.target.value })} placeholder='np. "premium, rzeczowy"' />
                        </Field>
                    </Grid2>
                    <Field label="Szablon przedstawiania się" hint="Placeholdery: {imie}, {kampania}, {firma}">
                        <FormTextarea value={style.introductionTemplate ?? ""} onChange={(e) => set({ introductionTemplate: e.target.value })} rows={2} />
                    </Field>
                </VStack>
            </SectionCard>

            <SectionCard>
                <SectionHeader number={18} title="Ton i forma komunikacji" subtitle="Jak Agent zwraca się do leada i jak długo pisze" />
                <VStack align="stretch" gap={3}>
                    <Field label="Forma zwracania się">
                        <FormSelect value={style.addressForm ?? ""} onChange={(v) => set({ addressForm: v || null })} options={ADDRESS_FORM_OPTIONS} placeholder="Wybierz formę" />
                    </Field>
                    <FormSwitch label="Używaj emoji" checked={!!style.useEmoji} onChange={(v) => set({ useEmoji: v })} />
                    <Grid2>
                        <Field label="Długość wiadomości">
                            <FormSelect value={style.messageLength ?? ""} onChange={(v) => set({ messageLength: v || null })} options={MESSAGE_LENGTH_OPTIONS} placeholder="Wybierz długość" />
                        </Field>
                        <Field label="Max. pytań na wiadomość">
                            <FormSelect
                                value={style.maxQuestionsPerMessage != null ? String(style.maxQuestionsPerMessage) : ""}
                                onChange={(v) => set({ maxQuestionsPerMessage: v ? Number(v) : null })}
                                options={MAX_QUESTIONS_OPTIONS}
                                placeholder="Wybierz limit"
                            />
                        </Field>
                    </Grid2>
                    <Field label="Styl zadawania pytań" hint='np. "bezpośrednio", "poprzez historie/przykłady"'>
                        <FormInput value={style.questionStyle ?? ""} onChange={(e) => set({ questionStyle: e.target.value })} />
                    </Field>
                    <Field label="Zasady follow-up w rozmowie">
                        <FormTextarea value={style.inConversationFollowUpRules ?? ""} onChange={(e) => set({ inConversationFollowUpRules: e.target.value })} rows={2} />
                    </Field>
                    <Field label="Sposób domykania rozmowy">
                        <FormTextarea value={style.closingStyle ?? ""} onChange={(e) => set({ closingStyle: e.target.value })} rows={2} />
                    </Field>
                </VStack>
            </SectionCard>

            <SectionCard>
                <SectionHeader number={19} title="Inicjatywa sprzedażowa" subtitle="Jak mocno Agent popycha rozmowę w stronę konwersji" />
                <VStack align="stretch" gap={3}>
                    <Field label="Poziom inicjatywy">
                        <FormSelect value={style.salesInitiativeLevel ?? ""} onChange={(v) => set({ salesInitiativeLevel: v || null })} options={SALES_INITIATIVE_OPTIONS} placeholder="Wybierz poziom" />
                    </Field>
                    <Field label="Zasady eskalacji i przekazania do handlowca">
                        <FormTextarea value={style.escalationRules ?? ""} onChange={(e) => set({ escalationRules: e.target.value })} rows={2} />
                    </Field>
                </VStack>
            </SectionCard>

            <SectionCard>
                <SectionHeader number={20} title="Dane, których agent nie może wymyślać" subtitle="Twarde ograniczenia -- jeśli informacji nie ma w bazie wiedzy" />
                <VStack align="stretch" gap={3}>
                    <Box bg="bg.highlight" borderRadius={8} p={3}>
                        <Text fontSize="xs" color="text.grey">
                            Jeśli Agent nie ma pewnej informacji, ma powiedzieć że musi sprawdzić, zebrać dane i przekazać pytanie handlowcowi -- nigdy nie zgadywać.
                        </Text>
                    </Box>
                    <RepeatableText
                        label="Ograniczenia"
                        values={style.forbiddenAssumptions ?? []}
                        onChange={(v) => set({ forbiddenAssumptions: v })}
                        placeholder='np. "Nie wymyślaj cen"'
                    />
                </VStack>
            </SectionCard>
        </VStack>
    );
};

export default StepConversationStyle;
